import React from "react";
import { Button, Select, Radio } from "antd";
import { Modal, Checkbox } from "antd";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import Axios from "../../../api/Axios";
const { Option } = Select;
const FilterClients = ({
  visible,
  naicsRes,
  setNaicsRes,
  relationshipType,
  clientType,
  applications,
  selectedApplications,
  setSelectedApplications,
  selectedNaics,
  setSelectedNaics,
  handleApply,
  handleCancel,
  handleClientTypeChange,
  handleRelationshipTypeChange,
  customerToClient,
  setCustomerToClient,
  ResetFields,
  expires,
  handleExpriySelect
}) => {
  //console.log(visible);
  //console.log(applications);

  const handleNaicsSearch = async (value) => {
    //console.log(value);
    if (value.length >= 2) {
      const response = await Axios.get(`/naicslist/?search=${value}`);
      //console.log(response);
      setNaicsRes(response.data);
    } else {
      setNaicsRes([]);
    }
  };

  const handleNaicsSelect = (value) => {
    //console.log(value);
    setSelectedNaics(value);
  };
  const handleApplicationsSelect = (value) => {
    //console.log(value);
    setSelectedApplications(value);
  };
  const handleCustomerClient = (e) => {
    //console.log(e.target.value, "setCustomerToClient");
    setCustomerToClient(e.target.value);
  };
  const handleNaicsBlur = () => {
    if (!selectedNaics) {
      setSelectedNaics("");
    }
  };

  return (
    <Modal
      title={<p className="modal-heading">FILTER CLIENTS</p>}
      onOk={handleApply}
      open={visible}
      footer={null}
      onCancel={handleCancel}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <p className="my-form-lables">RELATIONSHIP TYPE : </p>
        <Checkbox.Group
          options={[
            { label: "Client", value: "Client" },
            { label: "Prospect", value: "Prospect" },
          ]}
          onChange={handleRelationshipTypeChange}
          value={relationshipType}
          defaultValue={relationshipType}
          style={{ paddingLeft: "1rem", fontWeight: "600" }}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center", padding: "1rem" }}>
        <p className="my-form-lables">CLIENT TYPE : </p>
        <Checkbox.Group
          options={[
            { label: "Government", value: "govern" },
            { label: "Profit", value: "profit" },
            { label: "Non-profit", value: "non-profit" },
          ]}
          onChange={handleClientTypeChange}
          value={clientType}
          style={{
            paddingLeft: "1rem",
            fontWeight: "600",
          }}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center", padding: "1rem" }}>
        <p className="my-form-lables">NAICS Code : </p>
        <Select
          showSearch
          placeholder="Enter NAICS Code"
          filterOption={false}
          className="my-form-input"
          style={{
            width: "27.5rem",
            marginLeft: "2.5rem",
            borderRadius: "0.7rem",
            borderColor: "#818589",
          }}
          onSearch={handleNaicsSearch}
          onSelect={handleNaicsSelect}
          onBlur={handleNaicsBlur}
          value={selectedNaics}
          allowClear
          onClear={() => {
            setSelectedNaics("");
          }}
        >
          {/* <Option key={null} value={null}>
            None
          </Option> */}
          {naicsRes?.map((naics) => (
            <Option key={naics.code} value={naics.code}>
              {`${naics.title}`}
            </Option>
          ))}
        </Select>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
        }}
      >
        <p className="my-form-lables">APPLICATIONS : </p>
        <Select
          showSearch
          placeholder="Select Applications"
          className="my-form-input"
          style={{
            width: "27.5rem",
            marginLeft: "1rem",
            borderRadius: "0.7rem",
            borderColor: "#818589",
          }}
          onChange={handleApplicationsSelect}
          value={selectedApplications}
          mode="multiple"
        >
          {applications?.map((naics) => (
            <Option key={naics.id} value={naics.id}>
              {`${naics.name}`}
            </Option>
          ))}
        </Select>
      </div>
      <div 
      style={{
        display: "flex",
        alignItems: "center",
        padding: "1rem",
      }}>
      <p className="my-form-lables">EXPIRES IN : </p>
        <Select
          showSearch
          placeholder="Select Expiry"
          className="my-form-input"
          style={{
            width: "27.5rem",
            marginLeft: "4rem",
            borderRadius: "0.7rem",
            borderColor: "#818589",
          }}
          onChange={handleExpriySelect}
          value={expires}
          // mode=""
        >

          <Option value='30'>30 Days</Option>
          <Option value='60'>60 Days</Option>
          <Option value='90'>90 Days</Option>

          {/* {applications?.map((naics) => (
            <Option key={naics.id} value={naics.id}>
              {`${naics.name}`}
            </Option>
          ))} */}
        </Select>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
          marginBottom: "2rem",
        }}
      >
        <p className="my-form-lables">Customer Turned Into Client : </p>
        <Radio.Group
          onChange={handleCustomerClient}
          value={customerToClient}
          className="custom-checkbox-group"
          style={{
            paddingLeft: "1rem",
            fontWeight: "600",
          }}
        >
          <Radio value={false}>No</Radio>
          <Radio value={true}>Yes</Radio>
        </Radio.Group>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          height: "2rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Button key="back" onClick={handleCancel}>
          <CloseOutlined />
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={ResetFields}
          style={{ marginLeft: "1rem" }}
        >
          {/* <CloseOutlined /> */}
          Reset
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            background: "#f58029",
            fontWeight: "600",
            marginLeft: "1rem",
          }}
          onClick={handleApply}
          className="save-update-btn"
        >
          Apply
          <FormOutlined />
        </Button>
      </div>
    </Modal>
  );
};

export default FilterClients;
